import { CollectingCompanyFormItem } from 'components/waste-management/interfaces'
import { toFormDataPayload } from 'utils/serializers'

export const toCompanyPayload = (company: CollectingCompanyFormItem): FormData =>
  toFormDataPayload({
    name: company.name,
    email: company.email,
    contactNumber: company.contactNumber,
    contractNumber: company.contractNumber,
    tradeRegisterNumber: company.tradeRegisterNumber,
    cif: company.cif,
    headquarter: company.headquarter,
    county: company.county,
    iban: company.iban,
    bank: company.bank,
    environmentalPermitNumber: company.environmentalPermitNumber,
    environmentalPermitExpirationDate: company.environmentalPermitExpirationDate,
    ...(company.metiCodes?.length && {
      metiCodes: company.metiCodes.map((code: AutocompleteOption) => code.value)
    }),
    ...(company.metiCodesCsv && { metiCodesCsv: company.metiCodesCsv })
  })
